__turbopack_context__.v({
  "price": "PriceDisplay-module-scss-module__R3q_Oa__price",
  "price__current": "PriceDisplay-module-scss-module__R3q_Oa__price__current",
  "price__muted": "PriceDisplay-module-scss-module__R3q_Oa__price__muted",
});
